import { useState } from 'react';
import analytics, { TrackProps } from 'utils/analytics';

export const useInteractionTracker: () => (props: TrackProps) => Promise<void> =
  () => {
    const [hasInteracted, setHasInteracted] = useState(false);
    return async (props: TrackProps) => {
      if (!hasInteracted) {
        await analytics.track(props);
        setHasInteracted(true);
      }
    };
  };
